module.exports = __webpack_public_path__ + "img/kcc_img.0a77d779.png";